import store from '@/store'
export default class EditCartItemHelper {

    static store = store
    
    static editCartItem(codeOptions) {
        if (codeOptions) {
            var materialList = []
            materialList.push({
                code: codeOptions.materialNumber,
                itemNo: codeOptions.itemNo,
                isMarketOffer: codeOptions.isMarketOffer ?? false,
                forwardingAgent: codeOptions.forwardingAgent,
                isMultiPO: codeOptions.isMultiPO
            })
            localStorage.setItem('materialList',JSON.stringify(materialList))
            location.href = '/' + store.state.browser.languageCode + '/drawer.html?editItem=true'
        }
    }

    static editUnconfiguredOrNeedEditItems(entries,isMultiPO) {
        if (entries && entries.length != 0) {
            var materialList = []
            entries.forEach((entry) => {  
                materialList.push({
                    code: entry.product?.code,
                    itemNo: entry.sapLineItemNumber,
                    isMarketOffer: entry.isMarketOffer ?? false,
                    forwardingAgent: entry.forwardingAgent ?? '',
                    isMultiPO: isMultiPO
                })
            })
            localStorage.setItem('materialList',JSON.stringify(materialList))
            location.href = '/' + store.state.browser.languageCode + '/drawer.html?editItem=true'
        }
        

    }

}